module.exports = __webpack_public_path__ + "img/bus.b31ae5d4.svg";